import { CompanySize } from '../models/company-size.type';

export const COMPANY_SIZE_DEFAULTS: CompanySize[] = [
	{ from: 1, to: 5 },
	{ from: 6, to: 8 },
	{ from: 9, to: 44 },
	{ from: 45, to: 99 },
	{ from: 100 },
];
